import React, { useEffect, useRef } from "react";
import { Box, Typography } from "@mui/material";
import CloudOffIcon from "@mui/icons-material/CloudOffRounded";
import { useAppSelector } from "App/store/hooks";
import { useOnline } from "App/pwa";

/**
 * A strip across the top while the device is offline. When the connection
 * comes back and the saved session couldn't be restored offline (the token
 * refresh needs the network), reload so it restores — no new OTP needed.
 */
const OfflineBanner: React.FC = () => {
  const online = useOnline();
  const loggedIn = useAppSelector((state) => state.user.loggedIn);
  const wasOffline = useRef(false);

  useEffect(() => {
    if (!online) {
      wasOffline.current = true;
      return;
    }
    if (wasOffline.current && !loggedIn) {
      let saved = null;
      try {
        saved = localStorage.getItem("refreshToken");
      } catch {
        saved = null;
      }
      if (saved && saved !== "undefined") window.location.reload();
    }
  }, [online, loggedIn]);

  if (online) return null;
  return (
    <Box
      role="status"
      sx={{
        position: "fixed",
        left: 0,
        right: 0,
        top: 0,
        zIndex: 2000,
        pt: "env(safe-area-inset-top)",
        bgcolor: "#0f172a",
        color: "#fff",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 1, py: 0.75, px: 2 }}>
        <CloudOffIcon sx={{ fontSize: 18 }} />
        <Typography variant="body2" fontWeight={600}>You're offline — reconnect to see live rides and drivers.</Typography>
      </Box>
    </Box>
  );
};

export default OfflineBanner;
